import avatar0 from "../assets/avatars/avatar0.jpeg"
import avatar1 from "../assets/avatars/avatar1.jpeg"
import avatar2 from "../assets/avatars/avatar2.jpeg"
import avatar3 from "../assets/avatars/avatar3.jpeg"
import avatar4 from "../assets/avatars/avatar4.jpeg"
import avatar5 from "../assets/avatars/avatar5.jpeg"
import avatar6 from "../assets/avatars/avatar6.jpeg"
import avatar7 from "../assets/avatars/avatar7.jpeg"
import avatar8 from "../assets/avatars/avatar8.jpeg"
import avatar9 from "../assets/avatars/avatar9.jpeg"
import avatar10 from "../assets/avatars/avatar10.jpeg"
import avatar11 from "../assets/avatars/avatar11.jpeg"
import avatar12 from "../assets/avatars/avatar12.jpeg"
import avatar13 from "../assets/avatars/avatar13.jpeg"
import avatar14 from "../assets/avatars/avatar14.jpeg"
import avatar15 from "../assets/avatars/avatar15.jpeg"


 const avatars = [
  {name: "0", data: avatar0}, 
  {name: "1", data: avatar1}, 
  {name: "2", data: avatar2},
  {name: "3", data: avatar3},
  {name: "4", data: avatar4},
  {name: "5", data: avatar5}, 
  {name: "6", data: avatar6}, 
  {name: "7", data: avatar7}, 
  {name: "8", data: avatar8},
  {name: "9", data: avatar9},
  {name: "10", data: avatar10},
  {name: "11", data: avatar11},
  {name: "12", data: avatar12},
  {name: "13", data: avatar13},
  {name: "14", data: avatar14},
  {name: "15", data: avatar15},
];
 

export const handleAvatar = (useAvatar, avatarName, studentName) => {
  if(!useAvatar){    
    return <span>{studentName.includes(" ") ? studentName.substring(0,1) + "" + studentName.substring(studentName.indexOf(" ") + 1, studentName.indexOf(" ") + 2) : studentName.substring(0,1)}</span>
  }
  const result = avatars.find(e => e.name === avatarName);
  return result === null || result === undefined ? null : <img src={result.data} alt="Nutzer:innen avatar"></img>;
}